export default function createIri(base: string, id: string | number | undefined | null) {
  return `/${base}/${id}`
}
